export const NAV_LINKS = [
  { label: "NRI Fixed Deposits", href: "/#nri-fixed-deposits" },
  { label: "Home", href: "/#hero" },
  { label: "Who we are", href: "/#mission" },
  { label: "Services", href: "/#solutions" },
  { label: "Why Zenstrust", href: "/#why" },
  { label: "FAQ", href: "/#faq" },
  { label: "Blog", href: "/blog" },
];
